import getButtonTokens from './utils/getButtonTokens';
import getFocusTokens from './utils/getFocusTokens';
import getHoverTokens from './utils/getHoverTokens';
import getTextLinkTokens from './utils/getTextLinkTokens';
const componentsTokens = (mainColors) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, getButtonTokens(mainColors)), getTextLinkTokens(mainColors)), getHoverTokens(mainColors)), getFocusTokens(mainColors));
};
export default componentsTokens;
